var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-c",attrs:{"id":"website"}},_vm._l((_vm.imgList),function(item,index){return _c('van-image',{key:index,staticClass:"flex-self-ctr",attrs:{"src":item.url,"width":"10rem"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }